import {
    Error,
    GetAllFilesDetails,
    GetOneFileDetails,
    DeleteOneFileDetails,
    InsertOneFileDetails,
    UpdateOneFileDetails,
    getFilesDetailsLast
  } from "../type";
  const initialState = {
    FilesDetails: [],
    FilesDetailsLast: [],
    CreateFilesDetails: [],
    DeleteFileDetails: [],
    UpdateFileDetails: [],
    OneFileDetails:[],
    loading: false,
  };
  const FileDetailsR = (state = initialState, action) => {
    switch (action.type) {
      case GetAllFilesDetails:
        return {
          ...state,
          FilesDetails: action.payload,
          loading: false,
        };
        case getFilesDetailsLast:
          return {
            FilesDetails:state.FilesDetails,
            FilesDetailsLast: action.payload,
            loading: false,
          };
      case GetOneFileDetails:
        return {
          FilesDetails:state.FilesDetails,
          OneFileDetails: action.payload,
          loading: false,
        };
      case InsertOneFileDetails:
        return {
          FilesDetails:state.FilesDetails,
          CreateFilesDetails: action.payload,
          loading: false,
        };
      case UpdateOneFileDetails:
        return {
          FilesDetails:state.FilesDetails,
          UpdateFileDetails: action.payload,
          loading: false,
        };
      case DeleteOneFileDetails:
        return {
          FilesDetails:state.FilesDetails,
          DeleteFileDetails: action.payload,
          loading: false,
        };
      case Error:
        return {
          loading: false,
          FilesDetails: action.payload,
        };
      default:
        return state;
    }
  };
  export default FileDetailsR;
  